// @ah/news shared GraphQL queries — used by desktop and mobile.

export const RECOMMENDED_STORIES_QUERY = /* GraphQL */ `
  query RecommendedStories {
    recommendedStories(limit: 20) {
      id
      title
      snippet
      headlineImageUrl
      articleCount
      sourcePublishedAt
      summaryGeneratedAt
      topics { name id }
      summary {
        eli5
        whyItMatters
        relatedTopics
      }
    }
  }
`;

export const NEWS_LIST_QUERY = /* GraphQL */ `
  query NewsList {
    newsStories(limit: 30) {
      id
      title
      snippet
      headlineImageUrl
      articleCount
      sourcePublishedAt
      summaryGeneratedAt
      lastArticleSeenAt
      topics { name id }
      summary {
        eli5
        whyItMatters
        relatedTopics
      }
    }
  }
`;

const STORY_LIST_FIELDS = /* GraphQL */ `
  id
  title
  snippet
  headlineImageUrl
  articleCount
  sourcePublishedAt
  summaryGeneratedAt
  topics { name id }
  summary { eli5 whyItMatters relatedTopics }
`;

export const RECENTLY_READ_STORIES_QUERY = /* GraphQL */ `
  query RecentlyReadStories($limit: Int) {
    recentlyReadStories(limit: $limit) { ${STORY_LIST_FIELDS} }
  }
`;

export const SAVED_STORIES_QUERY = /* GraphQL */ `
  query SavedStories($limit: Int) {
    savedStories(limit: $limit) { ${STORY_LIST_FIELDS} }
  }
`;

export const RECORD_STORY_ENGAGEMENT_MUTATION = /* GraphQL */ `
  mutation RecordStoryEngagement($id: ID!) {
    recordStoryEngagement(id: $id)
  }
`;

export const RECORD_STORY_SAVE_MUTATION = /* GraphQL */ `
  mutation RecordStorySave($id: ID!) {
    recordStorySave(id: $id)
  }
`;

export const RECORD_STORY_UNSAVE_MUTATION = /* GraphQL */ `
  mutation RecordStoryUnsave($id: ID!) {
    recordStoryUnsave(id: $id)
  }
`;

export const NEWS_STORY_QUERY = /* GraphQL */ `
  query NewsStory($id: ID!) {
    newsStory(id: $id) {
      id
      title
      snippet
      headlineImageUrl
      sourceName
      sourceUrl
      sourcePublishedAt
      summaryGeneratedAt
      articleCount
      topics { name id }
      summary {
        whatHappened
        eli5
        longRead
        keyQuotes { quote speaker sourceName }
        keyStats { stat context sourceName }
        keyPeople { name role }
        whyItMatters
        relatedTopics
        sourcesCited { title url sourceName }
      }
      articles {
        id title snippet articleUrl sourceName publishedAt imageUrl extractionStatus
      }
      isSaved
    }
  }
`;
